// extracted by mini-css-extract-plugin
export var integrationButton = "_b2-0";